import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import IMAGE from "../../assets/images/big/abcz.png";
import { useEffect, useState } from "react";
import { useTMutation } from "../../utils/useTMutation";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import showToast from "../Hot-Toast/showToast";

const JobofferAccepted = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { jobData } = useSelector((state) => state.job);
  console.log("jobData", jobData);

  const { userDetails } = useSelector((state) => state?.user);
  const { mutateAsync } = useTMutation(
    "/job/saveAndRemoveJob",
    "post",
    (response) => {
      // leave empty or just log - logic handled in acceptOffer
      console.log("offer response", response);
    },
  );

  async function acceptOffer(value) {
    try {
      if (value === "Accept") {
        await mutateAsync({
          USER_ID: userDetails?.ID,
          JOB_ID: jobData?.ID,
          STATUS: "OfferAccepted",
        });
        showToast("success", "Offer accepted successfully");
        navigate("/clinician/myJobs");
      } else {
        await mutateAsync({
          USER_ID: userDetails?.ID,
          JOB_ID: jobData?.ID,
          STATUS: "OfferRejected",
        });
        showToast("success", "Offer rejected successfully");
        navigate("/clinician/myJobs");
      }
    } catch (error) {
      showToast("error", "Something went wrong. Please try again.");
    }
  }
  console.log("jobData.SERVICE_TYPdfdf", jobData);

  return (
    <>
      <Grid container style={{ marginTop: 60 }} justifyContent="center" pb={18}>
        <Grid lg={8}>
          <Box
            position="fixed"
            top={80}
            left={0}
            px={3}
            display="flex"
            alignItems="center"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/clinician/myJobs");
              // Forces a full reload
            }}
          >
            <ArrowBackIcon fontSize="small" />
            <Typography>Back</Typography>
          </Box>
          <Card>
            <Grid
              container
              alignItems="center"
              spacing={1}
              justifyContent="space-around"
              px={3}
              pt={2}
            >
              <Grid item xs={12} sm={12} display="flex" gap={3}>
                <Typography pt={2}>
                  <img src={IMAGE} alt="lt" />
                </Typography>
                <Typography>
                  <Box pt={2}>
                    <Typography
                      style={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#000000",
                        opacity: "87%",
                      }}
                    >
                      {userDetails?.FACILITY_NAME}
                    </Typography>
                    <Typography
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        color: "#000000",
                        opacity: "60%",
                      }}
                    >
                      {userDetails?.STREET_ADDRESS}
                    </Typography>
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography
                  sx={{
                    fontSize: "18px",
                    color: "rgba(0,0,0,0.87)",
                    fontWeight: 700,
                  }}
                >
                  {jobData?.ROLE_NAME}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                    margin: "auto",
                    fontWeight: 400,
                    marginBottom: "10px",
                  }}
                ></Box>

                {/* <Box>
                                <Typography variant="h2" pt={2} style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{props.data.JOB_ROLE_NAME}</Typography>
                                <Typography variant="h4" pt={2} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Saturday, June 15</Typography>
                                <Box display="flex" gap={1}>
                                    
                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>07:00 - 15:30</Typography>
                                </Box>
                                <Typography variant="h4" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>Glendora, CA</Typography>
                            </Box> */}
              </Grid>
            </Grid>

            <hr
              style={{
                marginTop: "20px",
                color: "#000000",
                opacity: "60%",
                width: "90%",
                margin: "0 auto",
              }}
            />
            {/* <Grid container px={1}>
            {jobDetailsUI.map((dtaUi) => {
              return (
                <Grid item lg={12}>
                  <Box display="flex" alignItems={"center"} px={2} pt={1.2}>
                    <Typography
                      variant="h4"
                      style={{
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#000000",
                        opacity: "87%",
                      }}>
                      {dtaUi.title}{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "#000000",
                        opacity: "60%",
                        paddingLeft: "3px",
                      }}>
                      {dtaUi.data}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid> */}
            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Title:{" "}
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.jobs_role?.ROLE_NAME}
              </Typography>
            </Box>

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Specialty:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.specialty?.SPECIALTY_NAME}
              </Typography>
            </Box>
            {jobData?.STAFFING_SOLUTION && (
              <Box display="flex" px={2} pt={1.2}>
                <Typography
                  variant="h4"
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    color: "#000000",
                    opacity: "87%",
                  }}
                >
                  Staffing Solution:
                </Typography>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#000000",
                    opacity: "60%",
                    paddingLeft: "3px",
                  }}
                >
                  {jobData?.STAFFING_SOLUTION}
                </Typography>

                <Typography></Typography>
              </Box>
            )}

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Job Type:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.JOB_TYPE}
              </Typography>
            </Box>

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Shift Type:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {jobData?.SERVICE_TYPE}
              </Typography>
            </Box>

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Start Date:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {new Date(jobData?.SERVICE_DATE).toDateString()}
              </Typography>
            </Box>
            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                End Date:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {new Date(jobData?.SERVICE_END_DATE).toDateString()}
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Working Days:
              </Typography>
              <Button onClick={() => setOpen(true)}>
                Job Service (Date & Time)
              </Button>
            </Box>

            <Box display="flex" px={2} pt={1.2}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#000000",
                  opacity: "87%",
                }}
              >
                Pay:
              </Typography>
              <Typography
                variant="h6"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#000000",
                  opacity: "60%",
                  paddingLeft: "3px",
                }}
              >
                {/* ${jobData?.PAY_AMOUNT_FROM}-{jobData?.PAY_AMOUNT_TO}/hr */}
                {jobData?.cliniciansInFacilityJobShifts?.length > 0
                  ? `$${jobData.cliniciansInFacilityJobShifts[0]?.clinicianPayRate}/hr`
                  : `$${jobData?.PAY_AMOUNT_FROM}-$${jobData?.PAY_AMOUNT_TO}/hr`}
              </Typography>
            </Box>

            <Grid item xs={12} sm={12} mt={3} px={2} pt={1.2}>
              <Typography
                variant="h5"
                style={{ fontWeight: 600, fontSize: "18px", color: "#000" }}
              >
                Facility Details
              </Typography>
              <Typography
                style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
              >
                <strong>Recruiter Name:</strong>{" "}
                {jobData?.user?.FULL_NAME || "N/A"}
              </Typography>
              <Typography
                style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
              >
                <strong>Recruiter Email:</strong>{" "}
                {jobData?.user?.EMAIL_ADDRESS || "N/A"}
              </Typography>
              <Typography
                style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
              >
                <strong>Recruiter Phone:</strong>{" "}
                {jobData?.user?.PHONE_NUMBER || "N/A"}
              </Typography>
              <Typography
                style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
              >
                <strong>Facility Name:</strong>{" "}
                {jobData?.user?.FACILITY_NAME || "N/A"}
              </Typography>
              <Typography
                style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
              >
                <strong>Location:</strong>{" "}
                {jobData?.user?.STREET_ADDRESS || "N/A"}
              </Typography>
              <Typography
                style={{ fontSize: "16px", color: "#000", opacity: "87%" }}
              >
                <strong>Website:</strong>{" "}
                {jobData?.user?.WEBSITE_NAME ? (
                  <Link
                    href={jobData?.user?.WEBSITE_NAME}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {jobData?.user?.WEBSITE_NAME}
                  </Link>
                ) : (
                  "N/A"
                )}
              </Typography>
            </Grid>

            {open && (
              <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="max-w-3xl">
                  <DialogTitle>
                    Job Services
                    <IconButton
                      aria-label="close"
                      onClick={() => setOpen(false)}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>

                  <div className="space-y-2">
                    {jobData?.jobSchedule?.SERVICE_DURATION?.length > 0 ? (
                      jobData.jobSchedule.SERVICE_DURATION.map(
                        (service, index) => (
                          <div
                            key={service.ID || index}
                            className="p-2 border rounded"
                          >
                            <p>
                              <strong>Day:</strong> {service.JOB_DAY || "N/A"}
                            </p>
                            <p>
                              <strong>In Time:</strong>{" "}
                              {service.JOB_IN_TIME || "N/A"}
                            </p>
                            <p>
                              <strong>Out Time:</strong>{" "}
                              {service.JOB_OUT_TIME || "N/A"}
                            </p>
                          </div>
                        ),
                      )
                    ) : (
                      <p>Schedule is yet to be defined by Facility.</p>
                    )}
                  </div>
                </DialogContent>
              </Dialog>
            )}
          </Card>

          <Box style={{ marginTop: 20 }}>
            <Card>
              <Grid
                container
                alignItems="center"
                spacing={1}
                justifyContent="space-around"
                p={3}
                pb={3}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#000000",
                      opacity: "87%",
                    }}
                  >
                    Job Description
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography
                    id="delete-modal-title"
                    variant="h6"
                    component="h2"
                    style={{
                      fontWeight: 400,
                      fontSize: "16px",
                      color: "#000000",
                      opacity: "60%",
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: jobData?.JOB_DESCRIPION,
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} mt={3}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography
                      variant="h3"
                      style={{
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#000000",
                        opacity: "87%",
                      }}
                    >
                      Responsibilities:
                    </Typography>
                  </Box>

                  <Typography pt={1}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: jobData?.JOB_RESPONSIBILITY,
                      }}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Box>
        </Grid>
      </Grid>
      {jobData?.cliniciansInFacilityJobShifts.map(
        (data) =>
          userDetails.ID === data?.clinicianId &&
          data?.offerStatus !== "OfferAccepted" && (
            <Grid
              container
              sx={{
                backgroundColor: "white",
                width: "100%",
                mr: 3,
                overflowX: "hidden",
              }}
            >
              <Grid item xs={12} sm={12} style={{ marginLeft: "250px" }}>
                <Typography
                  pt={3}
                  style={{ fontWeight: 400, fontSize: "18px" }}
                >
                  By selecting 
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "18px",
                      color: "#6ebe44",
                    }}
                  >
                    Confirm
                  </span>
                  , you agree that this job post reflects your requirements, and
                  agree it will be posted and applications will be processed
                  following EmpowerCare’s Terms, Cookie, and Privacy Policies.
                </Typography>
                <Stack
                  spacing={2}
                  px={8}
                  mt={3}
                  direction="row"
                  justifyContent="end"
                  alignItems="center"
                >
                  <Button
                    style={{ border: "1px solid #E2E8F0", color: "#EA4933" }}
                    onClick={() => {
                      acceptOffer("Reject");
                    }}
                  >
                    Reject
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                    onClick={() => {
                      acceptOffer("Accept");
                    }}
                  >
                    Accept Offer
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          ),
      )}
    </>
  );
};

export default JobofferAccepted;
